import * as Yup from "yup";

const user = JSON.parse(sessionStorage.getItem("authUser"));

const parseVehicle = (vehicleDetails) => {
    const vehicle = {
        vin: vehicleDetails.vin,        
        productionYear: vehicleDetails.productionYear, 
        mileage: vehicleDetails.mileage, 
        transmission: vehicleDetails.transmission, 
        brand: vehicleDetails.brand, 
        model: vehicleDetails.model, 
        engine: vehicleDetails.engine, 
        engineFuel: vehicleDetails.engineFuel, 
        enginePower: vehicleDetails.enginePower, 
        engineTag: vehicleDetails.engineTag, 
        bodyType: vehicleDetails.bodyType, 
        color: vehicleDetails.color, 
        purchasePrice: vehicleDetails.purchasePrice, 
        taxPrice: vehicleDetails.taxPrice, 
        sellerName: vehicleDetails.sellerName, 
        taxerName: vehicleDetails.taxerName, 
        isPaid: vehicleDetails.isPaid, 
        isTaxPaid: vehicleDetails.isTaxPaid,
        description: vehicleDetails.description 
    };
    return vehicle;
};

const workerValidationSchema = Yup.object({
    vin: Yup.string().length(17, "Broj šasije mora biti dug 17 karaktera").required("Molimo unesite broj šasije"),
    productionYear: Yup.number().positive("Izaberite godište").required("Izaberite godište"),
    mileage: Yup.number().positive("Molimo unesite kilometražu").required("Molimo unesite kilometražu"),
    transmission: Yup.number().positive("Izaberite tip transmisije").required("Izaberite tip transmisije"),
    brand: Yup.number().positive("Izaberite proizvođača").required("Izaberite proizvođača"),
    model: Yup.number().positive("Izaberite model").required("Izaberite model"),
    engine: Yup.number().positive("Izaberite kubikažu").required("Izaberite kubikažu"),
    engineFuel: Yup.number().positive("Izaberite tip goriva").required("Izaberite tip goriva"),
    enginePower: Yup.number().positive("Izaberite snagu").required("Izaberite snagu"),
    engineTag: Yup.number().positive("Izaberite oznaku").required("Izaberite oznaku"),
    bodyType: Yup.number().positive("Izaberite tip vozila").required("Izaberite tip vozila"),
});

const adminValidationSchema = Yup.object({
    vin: Yup.string().length(17, "Broj šasije mora biti dug 17 karaktera").required("Molimo unesite broj šasije"),
    productionYear: Yup.number().positive("Izaberite godište").required("Izaberite godište"),
    mileage: Yup.number().positive("Molimo unesite kilometražu").required("Molimo unesite kilometražu"),
    transmission: Yup.number().positive("Izaberite tip transmisije").required("Izaberite tip transmisije"),
    brand: Yup.number().positive("Izaberite proizvođača").required("Izaberite proizvođača"),
    model: Yup.number().positive("Izaberite model").required("Izaberite model"),
    engine: Yup.number().positive("Izaberite kubikažu").required("Izaberite kubikažu"),
    engineFuel: Yup.number().positive("Izaberite tip goriva").required("Izaberite tip goriva"),
    enginePower: Yup.number().positive("Molimo unesite snagu").required("Molimo unesite snagu"),
    engineTag: Yup.number().positive("Izaberite oznaku").required("Izaberite oznaku"),
    bodyType: Yup.number().positive("Izaberite tip vozila").required("Izaberite tip vozila"),
    purchasePrice: Yup.number("Molimo unesite cijenu i troškove transporta").positive("Molimo unesite cijenu i troškove transporta").required("Molimo unesite cijenu i troškove transporta"),
    taxPrice: Yup.number("Molimo unesite troškove carine i poreza").positive("Molimo unesite troškove carine i poreza").required("Molimo unesite troškove carine i poreza"),
        
});

const vehicleInit = {
    vin: "",        
    productionYear: "",
    mileage: 0,
    transmission: "",
    brand: "",
    model: "",
    engine: "",
    engineFuel: "",
    enginePower: "",
    engineTag: "",
    bodyType: "",
    color: "",        
    purchasePrice: 0,
    taxPrice: 0,
    sellerName: "",
    taxerName: "",
    isPaid: false,
    isTaxPaid: false,
    description: ""
};

const vehicleValidationSchema = user && user.role && user.role === "Admin" ? adminValidationSchema : workerValidationSchema;

export {
    vehicleInit,
    vehicleValidationSchema,
    parseVehicle
};